import AppNativeLayout from '@components/ui/app-layout';
import { createRootRoute, Outlet } from '@tanstack/react-router';
import { useEffect, useLayoutEffect } from 'react';
import { createUserSession, getItem } from '@utils/localStorage';
import { useAppDispatch, useAppSelector } from '@configs/store/hooks';
import * as shm from '@features/shm';
import { ComponentErrorBoundary } from '@components/errorBoundary';
import { useColorScheme } from '@mui/material';

const App = () => {
  const { mode, systemMode, setMode } = useColorScheme();
  const dispatch = useAppDispatch();
  const shmPrice = useAppSelector((state) => state?.shm?.price);
  const status = useAppSelector((state) => state.shm?.status);

  useLayoutEffect(() => {
    if (status === 'idle' && !shmPrice) {
      dispatch(shm.actions.fetchPrice());
    }
  }, []);

  useEffect(() => {
    const session = getItem('session');
    if (session?.sessionId) {
      return;
    } else {
      createUserSession();
    }
  }, []);
  return (
    <AppNativeLayout>
      <ComponentErrorBoundary>
        <Outlet />
      </ComponentErrorBoundary>
    </AppNativeLayout>
  );
};

export const rootRoute = createRootRoute({ component: App });

export default App;
